import { BaseError } from "@/domains/errors/kinds/BaseError";

export class StoreError extends BaseError {}
